/* eslint-disable no-console,  no-useless-escape */
const getParameterByName = (name, url) => {
  let location = url;
  if (!location) {
    location = window.location.href;
  }
  const regex = new RegExp(`[?&]${name.replace(/[\[\]]/g, '\\$&')}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location);
  if (!results) {
    return '';
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const detectProduction = function() {
  if (
    window.location.href.indexOf('www.vitaleblinds.com') !== -1 ||
    window.location.href.indexOf('https://vitaleblinds.com') !== -1 ||
    window.location.href.indexOf('http://vitaleblinds.com') !== -1
  ) {
    return true;
  }
  return false;
};

export {
  detectProduction,
  getParameterByName,
};
/* eslint-enable no-console, no-useless-escape */
